/**
 * Hard-coded figures for the bikPlusNetImpact net-cost calc. Likely future home is origo-admin product config.
 *
 * The WLC limit and maximum trade-up are read per driver grade from Jaama
 * (deloitteFilters.companyCostTotalTo and deloitteFilters.employeeCostSalarySacrificeTo), and the
 * trade-up amount itself is derived (WLC - WLC limit) - see bik-plus-net-impact.js.
 */

/**
 * NI rate (as a decimal fraction) per income-tax band (%).
 * Income tax rate itself comes from driverProfile.incomeTaxBand.ratePercent - not hard-coded here.
 *
 * @type {{ [rate: number]: number }}
 */
export const niRateByTaxBand = {
    20: 0.08,
    40: 0.02,
    45: 0.02,
};
